import React from "react";
import Button from "@material-ui/core/Button";
import ImportPlayersDialog from "../../components/teams/ImportPlayersDialog";
import { languages } from "../../constants/languages";

export default class ImportPlayersContainer extends React.Component {
  state = {
    open: false,
    playerList: "",
    submitDisabled: false
  };

  toggleDialog = () => {
    this.setState(prevState => ({
      open: !prevState.open,
      playerList: "",
      submitDisabled: false
    }));
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleKeyDown = event => {
    if (event.keyCode === 9) {
        // tab was pressed
        // get caret position/selection
        var start = event.target.selectionStart;
        var end = event.target.selectionEnd;

        var target = event.target;
        var value = target.value;
        // set textarea value to: text before caret + tab + text after caret
        target.value = value.substring(0, start) + "\t" + value.substring(end);
        // put caret at right position again (add one for the tab)
        this.selectionStart = this.selectionEnd = start + 1;

        // prevent the focus lose
        
        event.preventDefault();
        this.handleChange(event);
    }
    if (event.keyCode === 13 && event.ctrlKey) {
      this.handleSubmit(event);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    
    const db = window.firebase.firestore();
    let batch = db.batch();
    const playerRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("players");

    const teamsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams");

    let splitted = this.state.playerList.split("\n");

    // First get all teams to map team names to IDs
    teamsRef.get().then(snapshot => {
      const teams = {};
      snapshot.forEach(doc => {
        teams[doc.data().name.toLowerCase()] = doc.id;
      });

      // Process each player line
      for (let i in splitted) {
        console.log("Creating player: ",splitted[i]);
        let split = splitted[i];
        if (split !== "" && split !== " ") {
          let splittedSplit = split.split("\t");
          const teamName = (splittedSplit[3] || "").toLowerCase();
          const teamId = teams[teamName];

          if (teamId) {
            let playerData = {
              name: splittedSplit[0],
              age: splittedSplit[1] || "",
              number: splittedSplit[2] || "",
              team: teamId,
              division: this.props.division.id,
              createdAt: window.firebase.firestore.FieldValue.serverTimestamp(),
            };
            console.log("PlayerData player: ",playerData);
            let playerDoc = playerRef.doc();
            batch.set(playerDoc, playerData);
          }
        }
      }

      return batch.commit();
    })
    .then(() => {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("players_imported");
      }
      this.toggleDialog();
    })
    .catch(error => {
      console.error("Error importing players:", error);
      this.setState({ submitDisabled: false });
    });
  };

  render() {
    const user = window.firebase.auth().currentUser;
    if (!user || (
        user.uid !== "ROo6LrDGUbO705Hv0O3mnKVZrng2" && // Account Christiaan
        user.uid !== "1Aakz7G1nCSRtODZhU3DGgJYXb93" && // Account SportsGen
        user.uid !== "qwVXeKNiBzMz3RyUJSAJFLrkFnH2" // Account Abel
        )) {
      return null;
    }


    if (!user  && user.uid !== "") {
        return null;
      }
    return (
      <div>
         <Button
          size="small"
          variant="outlined"
          color="default"
          onClick={this.toggleDialog}
        >
          {languages.teams.importPlayers}
        </Button>
        <ImportPlayersDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleKeyDown={this.handleKeyDown}
          handleSubmit={this.handleSubmit}
          playerList={this.state.playerList}
          submitDisabled={this.state.submitDisabled}
        />
      </div>
    );
  }
} 